import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { ADGMTextField, AccordionLayout } from 'aurora-components';

import styles from './styles';

/** ****************
Props Documentation:
--------------------
label : label of the filter
isAccordion: flag to check if accordion layout is required
***************** */

const FiltersTextField = ({ classes, isAccordion, label, value, onChange, ...fieldProps }) => {
  const onChangeHandler = e => {
    const { name, value: data } = e.target;
    onChange(name, data);
  };
  if (isAccordion) {
    return (
      <AccordionLayout title={label} required={fieldProps?.required}>
        <div className={classes.container}>
          <ADGMTextField
            customClasses={{
              label: classes.label,
              field: classes.field,
              input: classes.input,
            }}
            onChange={onChangeHandler}
            {...fieldProps}
            value={value ?? ''}
          />
        </div>
      </AccordionLayout>
    );
  }

  return (
    <div className={classes.container}>
      <ADGMTextField
        label={label}
        customClasses={{
          label: classes.label,
          field: classes.field,
          input: classes.input,
        }}
        onChange={onChangeHandler}
        {...fieldProps}
        value={value ?? ''}
      />
    </div>
  );
};

FiltersTextField.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  isAccordion: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

FiltersTextField.defaultProps = {
  isAccordion: false,
  value: '',
};

export default withStyles(styles)(FiltersTextField);
